import { render, staticRenderFns } from "./TravelHome.vue?vue&type=template&id=0defe91e&scoped=true&"
import script from "./TravelHome.vue?vue&type=script&lang=js&"
export * from "./TravelHome.vue?vue&type=script&lang=js&"
import style0 from "./TravelHome.vue?vue&type=style&index=0&id=0defe91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defe91e",
  null
  
)

export default component.exports